var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status != '')?_c('div',[_c('h3',[_vm._v("Logged In")]),_c('p',[_vm._v("Loading details - Status: "+_vm._s(_vm.status))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }